import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AppState {
  isLoading: boolean;
  error: string;
}

const initialState: AppState = {
  isLoading: false,
  error: '',
};

export const appSlice = createSlice({
  name: 'appSlice',
  initialState,
  reducers: {
    setIsLoading(state: AppState, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setError(state: AppState, action: PayloadAction<string>) {
      state.error = action.payload;
    },
  },
});

export default appSlice.reducer;
